/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NdvrSecurity } from './NdvrSecurity';
import {
    NdvrSecurityFromJSON,
    NdvrSecurityFromJSONTyped,
    NdvrSecurityToJSON,
} from './NdvrSecurity';

/**
 * 
 * @export
 * @interface NdvrTrade
 */
export interface NdvrTrade {
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    side: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrTrade
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    orderType: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrTrade
     */
    quotePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof NdvrTrade
     */
    limitPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    priceSource?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    priceTimestamp?: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrTrade
     */
    optimizationId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NdvrTrade
     */
    isManualTrade: boolean;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    submitter?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    brokerInstruction?: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrTrade
     */
    estimatedMarketValue?: number;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    orderStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    parentOrderId?: string;
    /**
     * 
     * @type {NdvrSecurity}
     * @memberof NdvrTrade
     */
    security: NdvrSecurity;
    /**
     * 
     * @type {string}
     * @memberof NdvrTrade
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the NdvrTrade interface.
 */
export function instanceOfNdvrTrade(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "brokerId" in value;
    isInstance = isInstance && "orderType" in value;
    isInstance = isInstance && "isManualTrade" in value;
    isInstance = isInstance && "security" in value;

    return isInstance;
}

export function NdvrTradeFromJSON(json: any): NdvrTrade {
    return NdvrTradeFromJSONTyped(json, false);
}

export function NdvrTradeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NdvrTrade {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderId': json['order_id'],
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'side': json['side'],
        'quantity': json['quantity'],
        'aC': json['a_c'],
        'brokerId': json['broker_id'],
        'orderType': json['order_type'],
        'quotePrice': !exists(json, 'quote_price') ? undefined : json['quote_price'],
        'limitPrice': !exists(json, 'limit_price') ? undefined : json['limit_price'],
        'priceSource': !exists(json, 'price_source') ? undefined : json['price_source'],
        'priceTimestamp': !exists(json, 'price_timestamp') ? undefined : json['price_timestamp'],
        'optimizationId': !exists(json, 'optimization_id') ? undefined : json['optimization_id'],
        'isManualTrade': json['is_manual_trade'],
        'submitter': !exists(json, 'submitter') ? undefined : json['submitter'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'brokerInstruction': !exists(json, 'broker_instruction') ? undefined : json['broker_instruction'],
        'estimatedMarketValue': !exists(json, 'estimated_market_value') ? undefined : json['estimated_market_value'],
        'orderStatus': !exists(json, 'order_status') ? undefined : json['order_status'],
        'parentOrderId': !exists(json, 'parent_order_id') ? undefined : json['parent_order_id'],
        'security': NdvrSecurityFromJSON(json['security']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function NdvrTradeToJSON(value?: NdvrTrade | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_id': value.orderId,
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'side': value.side,
        'quantity': value.quantity,
        'a_c': value.aC,
        'broker_id': value.brokerId,
        'order_type': value.orderType,
        'quote_price': value.quotePrice,
        'limit_price': value.limitPrice,
        'price_source': value.priceSource,
        'price_timestamp': value.priceTimestamp,
        'optimization_id': value.optimizationId,
        'is_manual_trade': value.isManualTrade,
        'submitter': value.submitter,
        'reason': value.reason,
        'broker_instruction': value.brokerInstruction,
        'estimated_market_value': value.estimatedMarketValue,
        'order_status': value.orderStatus,
        'parent_order_id': value.parentOrderId,
        'security': NdvrSecurityToJSON(value.security),
        'created_at': value.createdAt,
    };
}

